import {Badge} from 'src/app/models/badge/badge';
import {AuthSupportType} from 'src/swagger-gen/web-secured/models';
import {SubPlanAssociationItemType} from '../enums/subPlanAssociationItemType';
import {SubPlanAssociationItemModel} from './subPlanAssociationItemModel';
import {BadgeType} from '../../../../../models/badge/badge-type';

export class SubPlanAssociationBadgeModel {
    displayName: string;
    uid: string;
    itemUid: string;
    itemType: SubPlanAssociationItemType;
    badgeType: AuthSupportType | BadgeType;
    badgeValue: string;

    constructor(badge: Badge, item: SubPlanAssociationItemModel) {
        this.uid = badge?.id || '';
        this.displayName = badge.value || '';
        this.itemUid = item.uid;
        this.itemType = item.type;
        this.badgeType = badge.type;
        this.badgeValue = badge.value;
    }
}
